// extracted by mini-css-extract-plugin
export default {"zoomModal":"h1-z"};